import React from 'react';
import * as S from './SimilarHotels.styles';
import CurrentHotelImage from '../CurrentHotelImage/CurrentHotelImage';
import SimilarHotelDetails from '../SimilarHotelDetails/SimilarHotelDetails';
import SimilarHotelAmenities from '../SimilarHotelAmenities/SimilarHotelAmenities';
import HotelPricingBlock from '../SimilarHotelPricing/SimilarHotelPricing';
import {defaultTheme} from 'build-theme/src/build-theme';
import HotelCardPersuasionsBlock from '../../SRP/HotelCard/HotelCardPersuasionsBlock';
import RupeeIcon from '../../../../Icons/RupeeIcon';

const SimilarHotels = React.forwardRef((props, ref) => {
  const {
    id,
    className,
    imageSrc,
    hotelName,
    hotelRating,
    hotelLocation,
    userRating,
    userRatingSource, // 🐨to be used if trip advisor logo has to be shown
    noOfReviews,
    coupleFriendly,
    payAtHotel,
    showPrice,
    slashedPrice,
    index,
    amenitiesList,
    onClick,
    currentHotel,
    persuasions,
  } = props;

  const {
    aboveRatePlanPersuasion,
    navigateToDetailsPage,
    roomTypeName,
    amenitiesIndexApplicableForHotel,
    amenitiesListMapping,
    contentPersuasion1,
    contentPersuasion2,
    belowBannerPersuasion
  } = persuasions;

  let fc = '';
  if (belowBannerPersuasion && belowBannerPersuasion[0] && belowBannerPersuasion[0].fd && belowBannerPersuasion[0].fd.fc) {
    fc = belowBannerPersuasion[0].pt;
  }

  return (
    <S.SimilarCaroCard id={id} className={className} sticky={currentHotel} currentHotel={currentHotel} ref={ref}>
      <S.SelectedHotelImgWrap>
        <S.SelectedImg src={imageSrc} alt="selected" />
      </S.SelectedHotelImgWrap>
      <S.SelectedHotelDetailBlock>
        <S.SelectedHotelName>{hotelName}</S.SelectedHotelName>
        <S.HtlRatingWrap>
          {!!hotelRating && new Array(hotelRating).fill(1).map((_, i) => (
            // <>*</>
            <S.StarDiv key={i}></S.StarDiv>
          ))}
        </S.HtlRatingWrap>
        <S.SelectedHotelPrice>
          <RupeeIcon {...priceRupeeIconProps} />
          {showPrice.toLocaleString('en-IN')}
        </S.SelectedHotelPrice>
        {/* <S.SelectedNightText>Per room per night</S.SelectedNightText> */}
        {// index -1 is explicityly deliberately passed for 'current hotel'
          index === -1 ? (
            <S.SelectedBtnWrap>
              <S.SelectedBtn>Select Room</S.SelectedBtn>
            </S.SelectedBtnWrap>
          ) : (
            <S.SelectedBtnWrap onClick={e => {
              onClick(e);
            }}>
              <S.SelectedViewBtn>View Details</S.SelectedViewBtn>
            </S.SelectedBtnWrap>
          )}
      </S.SelectedHotelDetailBlock>

      <S.SelectedUserRatingBlock>
          <S.SelectedRatingInfo>
              <S.SelectedUserRating>{userRating}/<span>5</span></S.SelectedUserRating>
              <S.SectedTotalReview>({noOfReviews} Reviews)</S.SectedTotalReview>
          </S.SelectedRatingInfo>
          {(coupleFriendly && <S.SelectedRecommendText>Recommended for couples</S.SelectedRecommendText>) || null}
      </S.SelectedUserRatingBlock>

      <S.SelectedLocation>
          <S.SelectedLocationText>{hotelLocation ? hotelLocation : '-'}</S.SelectedLocationText>
      </S.SelectedLocation>

      <S.SelectedCancelStatus>
          <S.SelectedCancelText>{fc !== '' ? 'Free Cancellation' : '-'}</S.SelectedCancelText>
          <S.SelectedCancelInfoText>{fc !== '' ? fc : '-'}</S.SelectedCancelInfoText>
      </S.SelectedCancelStatus>
      
      <S.SelectedEarlyCheck>
        <S.SelectedEarlyText>{roomTypeName}</S.SelectedEarlyText>
      </S.SelectedEarlyCheck>
    </S.SimilarCaroCard>
  );
});

export default SimilarHotels;

const priceRupeeIconProps = {
  fill: defaultTheme.colors.black.base,
  width: '1.6rem',
  height: '1.6rem',
};
